const { connect } = require('react-redux');
const { context } = require('app-context');
const { push: Push } = require('connected-react-router');
const ManageGroupsContents = require('components/ManageGroupsContents');

const selectors = context.selectors.all;
const actions = context.actions;
const redux = context.redux.hooks;

const internals = {};

module.exports = connect(
    (state) => ({
        allGroups: selectors.getGroups(state),
        groupSearchResults: selectors.getGroups_forGroupSearch(state),
        // Don't show unread badges for another user's groups list
        currentCommunityUnreadCounts: {},
        debug: selectors.getDebug(state).groupSorting
    }),
    (dispatch, { user }) => ({
        // mapDispatchToProps and mapStateToProps can receive `ownProps` as a 2nd argument in case you
        // need passed props in these funcs
        onRequestSearch: internals.fetchGroupSearchResults,
        fetchGroups: ({ managedUserId }) => dispatch(actions.dataFetching.fetchClasses({ managedUserId })),
        onClickAddToGroup: ({ id, name }) => dispatch(actions.classes.join({ id, name, userId: user.id })),
        onClickRemoveFromGroup: ({ id, name }) => dispatch(actions.classes.leave({ id, name, userId: user.id })),
        push: (...args) => dispatch(Push(...args))
    })
)(ManageGroupsContents);

// Need to store this func so it doesn't get re-generated every time mapDispatchToProps is run
// This is a new need because now that we're reading from passed props, redux knows to re-run mapDispatchToProps
// in case any of them have changed. The func itself is connected

// Normally re-evaluating these actions wouldn't really matter. In this particular component though, we're === checking
// to see if onRequestSearch has changed in the `componentWillReceiveProps` method.
// Without defining this in internals, the anonymous func below will be generated each render and the === check will always fail.
internals.fetchGroupSearchResults = (q) => redux.dispatch(actions.dataFetching.fetchGroupSearchResults(q));
